exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-form[data-v-9de63c5c]{text-align:left}.step-form .alert[data-v-9de63c5c]{width:480px;margin:0 auto}.step-form .form-list[data-v-9de63c5c]{margin-top:20px}", ""]);

// exports
